import React from "react";
import { useLocation } from "react-router-dom";
import { defaultSite } from "screens/helpers/commonHelper";
import InterviewAssistant from "screens/VAPI Ai/VAPIClient";
import VapiWidget from "screens/VAPI Ai/VAPIwidget";

const VoiceAgent = () => {
  const pubicKey = process.env.REACT_APP_VAPI_PUBLIC_KEY;
  const assistantId = process.env.REACT_APP_VAPI_ASSISTANT_ID;
  const location = useLocation();
  const selectedLocation = location?.state?.selectedLocation || {
    ...defaultSite,
  };
  return (
    <div className="h-100">
      {/* <VapiWidget assistantId={"assistantId"} publicKey={"pubicKey"} /> */}
      <InterviewAssistant
        assistantId={assistantId}
        publicKey={pubicKey}
        initialVars={{
          locationId: selectedLocation?.locationId,
          studies: selectedLocation?.studies,
          city: selectedLocation?.city,
          locationName: selectedLocation?.locationName,
        }}
      />
    </div>
  );
};

export default VoiceAgent;
